import Vue from 'vue'
import App from './App.vue'
import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueRouter from 'vue-router'
import { routes } from './routes'
import 'animate.css/animate.min.css';

//Firebase en Firestore instellingen
Vue.use(VueFire)
firebase.initializeApp({
    apiKey: "AIzaSyAaLoE6Y39VxegPqsnO66v3vDcXCzNnkq8",
    authDomain: "stevesfirsttodolist.firebaseapp.com",
    databaseURL: "https://stevesfirsttodolist.firebaseio.com",
    projectId: "stevesfirsttodolist",
    storageBucket: "stevesfirsttodolist.appspot.com",
    messagingSenderId: "970251233657"
});

//Firestore datum instellingen
const firestore = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);

//Firestore database export
export const db = firebase.firestore();

//Router instlellingen
Vue.use(VueRouter);
const router = new VueRouter({
	routes: routes,
	mode: 'history'
})

new Vue({
  el: '#app',
  render: h => h(App),
  router: router
})



// WEBPACK FOOTER //
// ./src/main.js